import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { selectDefTableSize } from '../../../../selectors/screenSelectors';
import DatePicker from '../../../common/table/DatePicker';
import StringInput from '../../../common/table/StringInput';
import createSelect from '../../../common/table/createSelect';

const statusOptions = [
    { value: true, label: 'Заблокований' },
    { value: false, label: 'Активний' }
];

class MariyaTable extends Component {
    render() {
        const { defaultPageSize } = this.props;
        const data = this.props.propsArray;

        return (
            <div className={`table-main-wrap ${!data.length && this.props.propsGetDataStatus === 'pending' ? 'table-main-wrap_loading' : ''}`}>
                <div className="table-header">Інформація про ЕККР Марія</div>
                <ReactTable
                    className=" -highlight"
                    columns={[
                        {
                            accessor: item => item.Location || '-----------',
                            Filter: StringInput,
                            Header: 'Адреса',
                            id: 'Location',
                            minWidth: 260
                        },
                        {
                            accessor: item => item.Number || '-----------',
                            Filter: StringInput,
                            Header: 'Серійний номер',
                            id: 'Number',
                            minWidth: 200
                        },
                        {
                            accessor: item => item.Blockage,
                            Cell: r => r.value ? new Date(r.value).toLocaleString() : '-----------',
                            Filter: DatePicker,
                            Header: 'Дата блокування',
                            id: 'Blockage',
                            minWidth: 180
                        },
                        {
                            accessor: item => item.Blocked,
                            Cell: r => {
                                const blocked = r.value === true;
                                const color = blocked ? '#c9302c' : '#36a566';
                                const text = blocked ? 'Заблокований' : 'Активний';

                                return <span style={{ display: 'flex', alignItems: 'center' }}><span style={{ display: 'inline-block', width: 12, height: 12, borderRadius: '50%', background: color, marginRight: 6 }} /> {text}</span>;
                            },
                            Filter: createSelect({ options: statusOptions, placeholder: 'Виберіть' }),
                            Header: 'Статус блокування',
                            id: 'Blocked',
                            minWidth: 200
                        }
                    ]}
                    data={data}
                    defaultPageSize={defaultPageSize}
                    filterable
                    filtered={this.props.filtered}
                    getTheadFilterThProps={() => ({
                        style: { overflow: 'visible', textAlign: 'left' }
                    })}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: () => {
                                    this.props.propsRowClick({ id: rowInfo.row._original.ID, index: rowInfo.index });
                                },
                                style: {
                                    backgroundColor: rowInfo.index === this.props.index ? '#B8B8B8' : 'white',
                                    color: rowInfo.index === this.props.index ? 'white' : 'black',
                                    cursor: 'pointer'
                                }
                            }
                        }
                        return {};
                    }}
                    manual
                    multiSort
                    nextText="Вперед"
                    NoDataComponent={() => null}
                    ofText="з"
                    onFilteredChange={this.props.handleOnFilterChange}
                    onPageChange={this.props.handleChangePage}
                    onPageSizeChange={this.props.handleChangePageSize}
                    onSortedChange={this.props.handleOnSortChange}
                    page={this.props.page}
                    pages={Math.ceil(this.props.count / this.props.pageSize)}
                    pageSize={this.props.pageSize}
                    pageText="Сторінка"
                    previousText="Назад"
                    rowsText="рядків"
                    sortable
                    sorted={this.props.sorted} />
                <div className="loading"></div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    defaultPageSize: selectDefTableSize(state),
});

export default connect(mapStateToProps)(MariyaTable);
